import {configureStore} from "@reduxjs/toolkit";

import websiteSlice from './reducer/website.reducer'
// import {persistStore, persistReducer} from "redux-persist";
// const persistConfig = {
//     key: "theme",
//     storage: AsyncStorage,
//     whitelist: ["theme"],
// };

// const persistedReducer = persistReducer(persistConfig, themeReducer);

export const store = configureStore({
    reducer: {
        // theme: persistedReducer,
        website: websiteSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

// export const persistor = persistStore(store);
